import en from "./en";
import es from "./es";
import fr from "./fr";
import it from "./it";
import de from "./de";

const guides = { en, es, fr, it, de };

export function getProviderGuide(language) {
  const lang = (language || "en").split("-")[0];
  return guides[lang] || guides.en;
}
